export default "__VITE_ASSET__C_902KPP__"